import { render } from "./errorPage3.vue?vue&type=template&id=4a9245e3"
import script from "./errorPage3.vue?vue&type=script&lang=js"
export * from "./errorPage3.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__